// PersonalChannelOnboarding — channel_2 self-service onboarding.
// Wraps the existing QR-code flow without surfacing the underlying
// provider implementation name to the user.
import QrCode from "./QrCode";
export default QrCode;
